import _, { pick } from 'underscore';

export class AssetLinkSchemaProcessor {
  constructor(options) {
    this.scope = options.scope;
    this.i18n = options.i18n;
    this.Permissions = options.globalConfig.get('Permissions');
  }

  updateEntitySchemaForFeatures(entitySchema) {
    const updatedEntitySchema = entitySchema;

    const { adType, campaignType, adSubType } = this.scope.values;

    const EditorialStatusEnumMap = {
      "Enum.EditorialStatus'Approved'": 'Approved',
      "Enum.EditorialStatus'ApprovedLimited'": 'ApprovedLimited',
      "Enum.EditorialStatus'Rejected'": 'Rejected',
      "Enum.EditorialStatus'Pending'": 'Pending',
      "Enum.EditorialStatus'ApprovedLimitedAppealRejected'": 'ApprovedLimitedAppealRejected',
      "Enum.EditorialStatus'RejectedAppealRejected'": 'RejectedAppealRejected',
      "Enum.EditorialStatus'AppealPending'": 'AppealPending',
    };

    updatedEntitySchema.properties.EditorialStatus = _.defaults({
      enum: _.keys(EditorialStatusEnumMap),
      enumValueMap: EditorialStatusEnumMap,
      localized: _.mapObject(EditorialStatusEnumMap, value => this.i18n.getString(`Asset_EditorialStatus_${value}`)),
    }, updatedEntitySchema.properties.EditorialStatus);

    const showAssetBasedEditorial = this.Permissions && ((this.Permissions.dynamic.AssetBasedEditorialForRSA && adType === 'ResponsiveSearch') || (this.Permissions.dynamic.AssetBasedEditorialForAIM && adSubType === 'native'));
    updatedEntitySchema.properties = pick(updatedEntitySchema.properties, [
      'UiDisplayStatus',
      'AssetAssetSource',
      'AssetId',
      'AssociationType',
      showAssetBasedEditorial ? 'EditorialStatus' : '',
    ]);

    // common part
    updatedEntitySchema.properties.UiDisplayStatus = _.defaults({
      enum: [
        "Enum.UiDisplayStatus'Active'",
        "Enum.UiDisplayStatus'Deleted'",
      ],
      enumValueMap: {
        "Enum.UiDisplayStatus'Active'": 'Active',
        "Enum.UiDisplayStatus'Deleted'": 'Deleted',
      },
    }, updatedEntitySchema.properties.UiDisplayStatus);

    updatedEntitySchema.properties.AssetAssetSource = _.defaults({
      chooseType: 'checkbox',
      enumType: 'AssetSource',
      enum: [
        "Enum.AssetSource'AdvertiserProvided'",
        "Enum.AssetSource'AutoGenerated'",
      ],
      enumValueMap: {
        "Enum.AssetSource'AdvertiserProvided'": 'AdvertiserProvided',
        "Enum.AssetSource'AutoGenerated'": 'AutoGenerated',
      },
    }, updatedEntitySchema.properties.AssetAssetSource);

    if (adType === 'Responsive') {
      updatedEntitySchema.properties.AssociationType = _.defaults({
        enum: [
          "Enum.AssetAssociationType'ResponsiveAdHeadlines'",
          "Enum.AssetAssociationType'ResponsiveAdLongHeadlines'",
          "Enum.AssetAssociationType'ResponsiveAdDescriptions'",
          "Enum.AssetAssociationType'OriginalImage'",
          "Enum.AssetAssociationType'SquareLogoMedia'",
          "Enum.AssetAssociationType'LandscapeLogoMedia'",
          "Enum.AssetAssociationType'LandscapeImageMedia'",
          "Enum.AssetAssociationType'SquareImageMedia'",
          "Enum.AssetAssociationType'ImageMedia1X2'",
          "Enum.AssetAssociationType'ImageMedia133X100'",
          "Enum.AssetAssociationType'ImageMedia15X10'",
          "Enum.AssetAssociationType'ImageMedia178X100'",
          "Enum.AssetAssociationType'ImageMedia4X1'",
          "Enum.AssetAssociationType'ImageMedia93X100'",
          "Enum.AssetAssociationType'ImageMedia155X100'",
          "Enum.AssetAssociationType'ImageMedia169X100'",
          "Enum.AssetAssociationType'ImageMedia172X100'",
          "Enum.AssetAssociationType'ImageMedia201X100'",
          "Enum.AssetAssociationType'ImageMedia200X100'",
          "Enum.AssetAssociationType'ImageMedia153X100'",
          "Enum.AssetAssociationType'ImageMedia124X100'",
          "Enum.AssetAssociationType'ImageMedia120X100'",
          "Enum.AssetAssociationType'CallToAction'",
        ],
        enumValueMap: {
          "Enum.AssetAssociationType'ResponsiveAdHeadlines'": 'ResponsiveAdHeadlines',
          "Enum.AssetAssociationType'ResponsiveAdLongHeadlines'": 'ResponsiveAdLongHeadlines',
          "Enum.AssetAssociationType'ResponsiveAdDescriptions'": 'ResponsiveAdDescriptions',
          "Enum.AssetAssociationType'OriginalImage'": 'OriginalImage',
          "Enum.AssetAssociationType'SquareLogoMedia'": 'SquareLogoMedia',
          "Enum.AssetAssociationType'LandscapeLogoMedia'": 'LandscapeLogoMedia',
          "Enum.AssetAssociationType'LandscapeImageMedia'": 'LandscapeImageMedia',
          "Enum.AssetAssociationType'SquareImageMedia'": 'SquareImageMedia',
          "Enum.AssetAssociationType'ImageMedia1X2'": 'ImageMedia1X2',
          "Enum.AssetAssociationType'ImageMedia15X10'": 'ImageMedia15X10',
          "Enum.AssetAssociationType'ImageMedia133X100'": 'ImageMedia133X100',
          "Enum.AssetAssociationType'ImageMedia178X100'": 'ImageMedia178X100',
          "Enum.AssetAssociationType'ImageMedia4X1'": 'ImageMedia4X1',
          "Enum.AssetAssociationType'ImageMedia93X100'": 'ImageMedia93X100',
          "Enum.AssetAssociationType'ImageMedia155X100'": 'ImageMedia155X100',
          "Enum.AssetAssociationType'ImageMedia169X100'": 'ImageMedia169X100',
          "Enum.AssetAssociationType'ImageMedia172X100'": 'ImageMedia172X100',
          "Enum.AssetAssociationType'ImageMedia201X100'": 'ImageMedia201X100',
          "Enum.AssetAssociationType'ImageMedia200X100'": 'ImageMedia200X100',
          "Enum.AssetAssociationType'ImageMedia153X100'": 'ImageMedia153X100',
          "Enum.AssetAssociationType'ImageMedia124X100'": 'ImageMedia124X100',
          "Enum.AssetAssociationType'ImageMedia120X100'": 'ImageMedia120X100',
          "Enum.AssetAssociationType'CallToAction'": 'CallToAction',
        },
      }, updatedEntitySchema.properties.AssociationType);

      if (this.Permissions && this.Permissions.dynamic.AudienceAssetReport && campaignType === 'Audience') {
        updatedEntitySchema.properties.AssociationType.enum.push("Enum.AssetAssociationType'VideoMedia16X9'", "Enum.AssetAssociationType'DisplayCreativeImage'");
        updatedEntitySchema.properties.AssociationType.enumValueMap["Enum.AssetAssociationType'VideoMedia16X9'"] = 'VideoMedia16X9';
        updatedEntitySchema.properties.AssociationType.enumValueMap["Enum.AssetAssociationType'DisplayCreativeImage'"] = 'DisplayCreativeImage';
      }
    } else if (adType === 'DynamicResponsive') {
      updatedEntitySchema.properties.AssociationType = _.defaults({
        enum: [
          "Enum.AssetAssociationType'Headlines'",
          "Enum.AssetAssociationType'Descriptions'",
          "Enum.AssetAssociationType'OriginalImage'",
          "Enum.AssetAssociationType'SquareLogoMedia'",
          "Enum.AssetAssociationType'LandscapeLogoMedia'",
          "Enum.AssetAssociationType'LandscapeImageMedia'",
          "Enum.AssetAssociationType'SquareImageMedia'",
          "Enum.AssetAssociationType'ImageMedia1X2'",
          "Enum.AssetAssociationType'ImageMedia133X100'",
          "Enum.AssetAssociationType'ImageMedia15X10'",
          "Enum.AssetAssociationType'ImageMedia178X100'",
          "Enum.AssetAssociationType'ImageMedia4X1'",
          "Enum.AssetAssociationType'ImageMedia93X100'",
          "Enum.AssetAssociationType'ImageMedia155X100'",
          "Enum.AssetAssociationType'ImageMedia169X100'",
          "Enum.AssetAssociationType'ImageMedia172X100'",
          "Enum.AssetAssociationType'ImageMedia201X100'",
          "Enum.AssetAssociationType'ImageMedia200X100'",
          "Enum.AssetAssociationType'ImageMedia153X100'",
          "Enum.AssetAssociationType'ImageMedia124X100'",
          "Enum.AssetAssociationType'ImageMedia120X100'",
          "Enum.AssetAssociationType'DisplayCreativeImage'",
          "Enum.AssetAssociationType'CallToAction'",
        ],
        enumValueMap: {
          "Enum.AssetAssociationType'Headlines'": 'Headlines',
          "Enum.AssetAssociationType'Descriptions'": 'Descriptions',
          "Enum.AssetAssociationType'OriginalImage'": 'OriginalImage',
          "Enum.AssetAssociationType'SquareLogoMedia'": 'SquareLogoMedia',
          "Enum.AssetAssociationType'LandscapeLogoMedia'": 'LandscapeLogoMedia',
          "Enum.AssetAssociationType'LandscapeImageMedia'": 'LandscapeImageMedia',
          "Enum.AssetAssociationType'SquareImageMedia'": 'SquareImageMedia',
          "Enum.AssetAssociationType'ImageMedia1X2'": 'ImageMedia1X2',
          "Enum.AssetAssociationType'ImageMedia15X10'": 'ImageMedia15X10',
          "Enum.AssetAssociationType'ImageMedia133X100'": 'ImageMedia133X100',
          "Enum.AssetAssociationType'ImageMedia178X100'": 'ImageMedia178X100',
          "Enum.AssetAssociationType'ImageMedia4X1'": 'ImageMedia4X1',
          "Enum.AssetAssociationType'ImageMedia93X100'": 'ImageMedia93X100',
          "Enum.AssetAssociationType'ImageMedia155X100'": 'ImageMedia155X100',
          "Enum.AssetAssociationType'ImageMedia169X100'": 'ImageMedia169X100',
          "Enum.AssetAssociationType'ImageMedia172X100'": 'ImageMedia172X100',
          "Enum.AssetAssociationType'ImageMedia201X100'": 'ImageMedia201X100',
          "Enum.AssetAssociationType'ImageMedia200X100'": 'ImageMedia200X100',
          "Enum.AssetAssociationType'ImageMedia153X100'": 'ImageMedia153X100',
          "Enum.AssetAssociationType'ImageMedia124X100'": 'ImageMedia124X100',
          "Enum.AssetAssociationType'ImageMedia120X100'": 'ImageMedia120X100',
          "Enum.AssetAssociationType'DisplayCreativeImage'": 'DisplayCreativeImage',
          "Enum.AssetAssociationType'CallToAction'": 'CallToAction',
        },
      }, updatedEntitySchema.properties.AssociationType);
    } else {
      updatedEntitySchema.properties.AssociationType = _.defaults({
        enum: [
          "Enum.AssetAssociationType'Headlines'",
          "Enum.AssetAssociationType'Descriptions'",
        ],
        enumValueMap: {
          "Enum.AssetAssociationType'Headlines'": 'Headlines',
          "Enum.AssetAssociationType'Descriptions'": 'Descriptions',
        },
      }, updatedEntitySchema.properties.AssociationType);
    }

    return updatedEntitySchema;
  }

  updateOdataOptions(odataOptions) {
    _.extendOwn(odataOptions.custom, {
      EditorialStatus: {
        eq: (filterValues) => {
          const queryStr = `EditorialStatus eq ${filterValues.replace('Enum.EditorialStatus\'AppealPending\'', 'Enum.EditorialStatus\'RejectedAppealPending\' or EditorialStatus eq Enum.EditorialStatus\'ApprovedLimitedAppealPending\'')}`;
          return queryStr;
        },
      },
    });

    return odataOptions;
  }
}

